module.exports = __webpack_public_path__ + "static/media/important_devices.eedb4b86.svg";